import Vue from './app.js';
import {router} from './app.js';

export default {
  create(context, surname, name, type, email, password, role, solde) {
		Vue.http.post(
			'api/utilisateurs/new',
			{
				surname: surname,
				name: name,
				type: type,
				email: email,
				password: password,
				role: role,
				solde: solde
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.utilisateurs();
				context.showSuccessCreate();
			}
		})
	},
  update(context, id, surname, name, type, email, role, solde, password) {
		Vue.http.post(
			'api/utilisateurs/update',
			{
			  id: id,
			  surname: surname,
			  name: name,
			  type: type,
			  email: email,
			  role: role,
			  solde: solde,
			  password: password
			}
		).then(response => {
			context.response = response.data
			console.log(response.data)
			if (context.response.error) {
				context.showError();
			}
			else {
				context.utilisateurs();
				context.showSuccessUpdate();
			}
		})
	},
  destroy(context, id) {
		Vue.http.post(
			'/api/utilisateurs/delete',
			{
				id: id
			}
		).then(response => {
			console.log(response)
			context.response = response.data
		  if (context.response.error) {
				context.showError();
			}
			else {
				context.utilisateurs();
				context.showSuccessDelete();
			}
		})
  }
}



// WEBPACK FOOTER //
// ./assets/js/users.js